const initialState = {
  isOverlayOpen: false,
};

export default initialState;
